import { Component, computed, inject, input, output, signal } from '@angular/core';

import { FileDisplayCardComponent, FilesSlideComponent } from '@camelot/files-basic';
import { InputUploadValue } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import { CamDocumentsService, DocumentDto, FileType } from '@camelot/services';
import { TranslatePipe } from '@camelot/translation';
import { ButtonToolComponent, LayoutFullPanelComponent, TextComponent } from '@camelot/ui';
import { CamAbstractComponent, FileSizePipe, ModalState } from '@camelot/utils';

import { CamTranslationCommunication } from '../../../translation.service';

type AttachmentTile = {
  document: DocumentDto;
  value: InputUploadValue;
};

@Component({
  imports: [
    ButtonToolComponent,
    FileDisplayCardComponent,
    FileSizePipe,
    FilesSlideComponent,
    FontIconComponent,
    LayoutFullPanelComponent,
    TextComponent,
    TranslatePipe,
  ],
  selector: 'cam-message-box-attachments',
  styleUrl: './attachments.component.scss',
  templateUrl: './attachments.component.html',
})
export class MessageBoxAttachmentsComponent extends CamAbstractComponent {
  attachments = input.required<InputUploadValue[]>();

  readonly = input(false);

  remove = output<InputUploadValue>();

  // cam-file-display-card attend un DocumentDto : on retombe sur la valeur uploadée
  // tant que le document n'est pas encore dans le cache du service
  public tiles = computed<AttachmentTile[]>(() =>
    this.attachments().map(attachment => ({
      document: this._documentsService.getDocuments([attachment.id])?.[0] ?? {
        fileType: FileType.Unknown,
        id: attachment.id,
        name: attachment.name,
        uploadedDate: '',
        url: attachment.url,
      },
      value: attachment,
    }))
  );

  public totalSize = computed(() => this.tiles().reduce((total, tile) => total + (tile.document.size ?? 0), 0));

  public collapsed = signal(false);

  public previewModal = new ModalState<{ files: DocumentDto[]; initial: DocumentDto }, null>();

  private readonly _documentsService = inject(CamDocumentsService);

  constructor() {
    super();
    CamTranslationCommunication.getInstance();
  }

  public toggleCollapsed() {
    this.collapsed.update(value => !value);
  }

  public openPreview(document: DocumentDto) {
    this.previewModal.asked({
      files: this.tiles().map(tile => tile.document),
      initial: document,
    });
  }
}
